import { Component } from '@angular/core';

@Component({
  selector: 'app-natural-stone-finalize-preorder-info',
  standalone: true,
  imports: [],
  templateUrl: './natural-stone-finalize-preorder-info.component.html',
  styleUrl: './natural-stone-finalize-preorder-info.component.scss'
})
export class NaturalStoneFinalizePreorderInfoComponent {

}
